import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiAlertTriangle, FiRefreshCw } from 'react-icons/fi';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
    this.handleRetry = this.handleRetry.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error("Uncaught error:", error, errorInfo);
  }

  handleRetry() {
    this.setState({ hasError: false, error: null, errorInfo: null });
    // Optional: reload page if it's a critical failure?
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
          return this.props.fallback;
      }

      return (
        <div className="flex flex-col items-center justify-center p-8 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800 text-center min-h-[200px]">
          <div className="bg-red-100 dark:bg-red-800 p-3 rounded-full mb-4">
             <SafeIcon icon={FiAlertTriangle} className="text-red-600 dark:text-red-200 text-2xl" />
          </div>
          <h3 className="text-lg font-semibold text-red-900 dark:text-red-100 mb-2">Something went wrong</h3>
          <p className="text-red-700 dark:text-red-300 text-sm mb-6 max-w-md">
            We encountered an unexpected error while rendering this component.
          </p>

          <button
             onClick={this.handleRetry}
             className="flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors shadow-sm"
          >
             <SafeIcon icon={FiRefreshCw} className="mr-2" />
             Try Again
          </button>

          {/* Optional: Dev details */}
          {import.meta.env.MODE === 'development' && this.state.error && (
             <details className="mt-4 text-left w-full text-xs text-red-800 dark:text-red-300 whitespace-pre-wrap overflow-auto max-h-40 bg-red-100 dark:bg-red-900/40 p-2 rounded">
                {this.state.error && this.state.error.toString()}
                <br />
                {this.state.errorInfo.componentStack}
             </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
